module.exports = __webpack_public_path__ + "assets/img/btn_exchange.b484a99c.png";